import { jsxs as u, Fragment as C, jsx as t } from "react/jsx-runtime";
import { useBreakpoint as _, Breakpoints as b, useNextgenRouter as y, useSession as B, GenericLink as x, NextgenImage as S, LoaderType as w } from "@nextgen-web-framework/all";
import { useState as N } from "react";
import { Logger as L } from "@nextgen-web-framework/core";
import v from "../SkeletonLoader/SkeletonLoader.js";
import { createDynamicUrl as G } from "../../utils/dynamicUrlGenerator.js";
import '../../assets/ShopByBrands.css';const O = "#ffffff", R = "#396e75", q = "#e5fdff", I = "#546223", T = "#f0fae5", W = "#a65523", E = "#fff1e8", Y = "#7f3e3e", A = "#ffe2e2", U = "#62625a", $ = "#f8f8e7", j = "#38539a", M = "#707070", D = "#c8f8d1", F = "#87c9c8", K = "#5291b1", P = "rgba(82, 145, 177, 0.1019607843)", X = "#445685", H = "#181d61", J = "rgba(24, 29, 97, 0.1019607843)", Q = "#5969d6", Z = "#ea999d", aa = "#b6577e", oa = "rgba(182, 87, 126, 0.1019607843)", ra = "#7e3e80", ea = "#1e247f", na = "rgba(30, 36, 127, 0.1019607843)", ta = "#da7600", ia = "#107f47", da = "#d91734", la = "_html_18xqf_38", i = {
  amwayWhite: O,
  darkBlue: R,
  lightBlue: q,
  darkGreen: I,
  lightGreen: T,
  darkOrange: W,
  lightOrange: E,
  darkRed: Y,
  lightRed: A,
  darkYellow: U,
  lightYellow: $,
  darkPurple: j,
  darkGrayOnWhite: M,
  dataVizColor1: D,
  dataVizColor2: F,
  dataVizColor3: K,
  dataVizColor3Background: P,
  dataVizColor4: X,
  dataVizColor5: H,
  dataVizColor5Background: J,
  dataVizColor6: Q,
  dataVizColor7: Z,
  dataVizColor8: aa,
  dataVizColor8Background: oa,
  dataVizColor9: ra,
  dataVizColor10: ea,
  dataVizColor10Background: na,
  dataVizAlertOrange: ta,
  dataVizSuccessGreen: ia,
  dataVizWarningRed: da,
  "no-visible": "_no-visible_18xqf_34",
  html: la,
  "brand-image-link": "_brand-image-link_18xqf_72",
  "shopbybrand-image-container": "_shopbybrand-image-container_18xqf_78",
  "brand-image-container": "_brand-image-container_18xqf_87",
  "inner-container": "_inner-container_18xqf_95",
  "brand-image": "_brand-image_18xqf_72",
  "shopby-header-menu": "_shopby-header-menu_18xqf_119"
}, sa = (r, l, e) => {
  var d;
  const s = (d = r.link) == null ? void 0 : d.url, { queryParams: n } = r;
  return n != null && n.length ? G(s, n, l, e) : s;
}, ba = (r) => {
  const l = _(), e = [b.SM, b.XS].includes(l), s = y(), { session: n } = B(), [d, z] = N(!0), h = L.getInstance({ component: "ShopByBrands.tsx", product: "commerce-webcomponent" }), m = [], V = (a) => {
    try {
      m.push(a), r.categories.length === m.length && z(!1);
    } catch (o) {
      h.log("Error while loading Images setImageLoading ", o);
    }
  }, k = (a) => {
    var c;
    const o = (c = a == null ? void 0 : a.imageList) == null ? void 0 : c.find((g) => g.viewport.includes(l));
    return (o == null ? void 0 : o.url) || "";
  };
  return /* @__PURE__ */ u(C, { children: [
    e && /* @__PURE__ */ t("div", { className: i["shopby-header-menu"], children: r.allTitle }),
    /* @__PURE__ */ t(
      "div",
      {
        id: "shopby-brands-storybook-id",
        className: i["shopbybrand-image-container"],
        "data-testid": "shopbybrand-image-container-id",
        "data-pod-name": "commerce",
        children: r.categories.map((a, o) => {
          var g, f;
          const c = sa(a, (g = s.params) == null ? void 0 : g.locale, n.aboNum ?? "");
          return /* @__PURE__ */ t(
            x,
            {
              href: c || "",
              className: i["brand-image-link"],
              target: (f = a == null ? void 0 : a.link) == null ? void 0 : f.target,
              children: /* @__PURE__ */ t("div", { className: i["brand-image-container"], children: /* @__PURE__ */ u("div", { className: i["inner-container"], children: [
                /* @__PURE__ */ t(
                  S,
                  {
                    className: `lazy-image-shop-by-brand ${i["brand-image"]}`,
                    src: k(a),
                    alt: a.altText,
                    loaderType: w.CONTENTSTACK,
                    onError: (p) => h.log("Error while loading Images ShopByBrand- ", p),
                    style: !e && d ? { visibility: "hidden" } : {},
                    onLoad: () => !e && V(o)
                  }
                ),
                !e && d && /* @__PURE__ */ t(v, { height: 120, borderRadius: 12 })
              ] }) })
            },
            `${a.title}-${o.toString()}`
          );
        })
      }
    )
  ] });
};
export {
  ba as default
};
//# sourceMappingURL=ShopByBrands.js.map
